import { SVGProps, Ref, forwardRef } from 'react';

export const IbsSolidSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M15.48 16.902a.625.625 0 0 1 .615.614.61.61 0 0 1-.618.608l.003.004h-1.227v-1.226z"
                fill="currentColor"
            />
            <path
                d="M15.427 13.884a.592.592 0 0 1 .578.583.605.605 0 0 1-.586.589l-1.17-.004v-1.168z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M32 29.5a2.5 2.5 0 0 1-2.5 2.5h-27A2.5 2.5 0 0 1 0 29.5v-27A2.5 2.5 0 0 1 2.5 0h27A2.5 2.5 0 0 1 32 2.5zM5.527 13.884h.684v4.232h-.684v1.957H9.95v-1.957h-.683v-4.232h.683v-1.957H5.527zm5.241.008h.684v4.224h-.684v1.956h6.183a2.25 2.25 0 0 0 1.515-.72c.393-.427.605-.988.593-1.567a2.04 2.04 0 0 0-1.38-1.917l.009-.032a1.895 1.895 0 0 0 1.105-1.858c0-1.054-.82-2.043-2.236-2.043h-5.789zm11.525-1.957c-1.584 0-2.83.935-2.83 2.528a2.45 2.45 0 0 0 1.566 2.286c.306.119.632.174.96.165h1.667a.616.616 0 0 1 .615.613.61.61 0 0 1-.615.614h-1.228v-.602H19.89v2.533h4.623a2.539 2.539 0 0 0 2.543-2.536 2.497 2.497 0 0 0-2.551-2.484l-1.692.004a.603.603 0 0 1-.584-.589.59.59 0 0 1 .584-.583h1.172v.572h2.517v-2.521z"
                fill="currentColor"
            />
        </g>
    </svg>
));
IbsSolidSize32Glyph.displayName = 'IbsSolidSize32Glyph';
